/*
 *
 *  * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *  *    .       .       .       .       .       .       .       .       .       .       .       .
 *  *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *  *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *  *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *  *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *  *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *  *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *  *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *  *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *  *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *  *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *  *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *  *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *  *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *  *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *  *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *  *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *  *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *  *
 *  * Copyright FortyFix(c) 2025.
 *  * Title: DefaultCrm.ts;
 *  * Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/environments/BaseEnvironments/DefaultCrm.ts;
 *  * Description: ;
 *  * Author: Della Porta Giovanni Battista;
 *  * Created at: 07/11/25, 10:44;
 *  * Updated at: 07/11/25, 10:44;
 *
 */

import { Marketing } from '../Modules/Marketing';
import { Prodotti } from '../Modules/Prodotti';
import { getModule, addModule } from '../Utility/ModuleUtility';



var Environment = () => {
  var env: any = {
    baseUrl: '/marketing/database-clienti',
  };
  env = addModule(Prodotti(), env);
  env = addModule(Marketing(), env);
  env.Modules = {
    "Dashboard" : true,
    "Marketing": true,
    "Clienti": true,
    "Progetti": true,
    "Prodotti": true
  }
  env.DashboardAddon =  [
    {
      url: '/anagrafica/crm/dashboard',
      initObj: [

      ],
      filters: [
        { nome: "Inizio", oggetti: ["inizio"], modificabile: true, inputType: "date", class: "col-lg-3"},
        { nome: "Fine", oggetti: ["fine"], modificabile: true, inputType: "date", class: "col-lg-3"}
      ],

      campi: [
        { nome: "Account Registrati nel Periodo", tipo: "text", oggetto: "num_account_periodo", larghezza:'col-lg-4', class: 'bg-kindera' },
        { nome: "Contatti Registrati nel Periodo", tipo: "text", oggetto: "num_contatti_periodo", larghezza:'col-lg-4', class: 'bg-kindera' },
        { nome: "Lead Registrati nel Periodo", tipo: "text", oggetto: "num_lead_periodo", larghezza:'col-lg-4', class: 'bg-kindera' },

        {
          dataFunc: (x) => {
            return [
              { label: 'Account', value: x.account },
              { label: 'Precedenti', value: x.account_precedente },
            ]
          },
          nome: "Account", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },

        {
          dataFunc: (x) => {
            return [
              { label: 'Contatti', value: x.contatti },
              { label: 'Precedenti', value: x.contatti_precedente },
            ]
          },
          nome: "Contatti", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },

        {
          dataFunc: (x) => {
            return [
              { label: 'Lead', value: x.lead },
              { label: 'Precedenti', value: x.lead_precedente },
            ]
          },
          nome: "Lead", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },

        {
          dataFunc: (x) => {
            return [
              { label: 'Ordini', value: x.ordini },
              { label: 'Precedenti', value: x.ordini_precedente },
            ]
          },
          nome: "Ordini", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },

        {
          dataFunc: (x) => {
            return [
              { label: 'Acquirenti', value: x.clienti },
              { label: 'Precedenti', value: x.clienti_precedente },
            ]
          },
          nome: "Acquirenti", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },

        {
          dataFunc: (x) => {
            return [
              { label: 'Ordini', value: x.ordini },
              { label: 'Precedenti', value: x.ordini_precedente },
            ]
          },
          nome: "Ordini", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },

        {
          dataFunc: (x) => {
            return [
              { label: 'Venduto', value: x.venduto },
              { label: 'Precedenti', value: x.venduto_precedente },
            ]
          },
          nome: "Venduto", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },



        {
          dataFunc: (x) => {
            return [
              { label: 'Contatti', value: x.contatti },
              { label: 'Lead', value: x.lead },
              { label: 'Acquirenti', value: x.clienti }
            ]
          },
          nome: "Panoramica Generale: contatti, lead e clienti", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },

        /*{ nome: "Beneficiari(e) con interventi", tipo: "text", oggetto: "utenti_attivi", larghezza:'col-lg-3', class: 'bg-info' },
        { nome: "Totale interventi", tipo: "text", oggetto: "num_int_totale", class: 'bg-info', larghezza:'col-lg-3', clickLink: 'task/attivita?fromdashboard=true&periodo=0&approvato=1' },
        { nome: "Totale interventi in corso", tipo: "text", oggetto: "num_int_aperti_totale", larghezza:'col-lg-3', class: 'bg-info', clickLink: 'task/attivita?periodo=0&chiuso=0' },
        { nome: "Beneficiari(e)", tipo: "text", oggetto: "utenti_creati", class: 'bg-warning', larghezza:'col-lg-3' },
        { nome: "Interventi Nuovi Beneficiari", tipo: "text", oggetto: "num_int_creati", larghezza:'col-lg-3', class: 'bg-warning' },
        { nome: "Interventi", tipo: "text", oggetto: "num_int", class: 'bg-warning', larghezza:'col-lg-3', clickLink: 'task/attivita?fromdashboard=true&chiuso=1&approvato=1' },
        { nome: "Interventi in corso", tipo: "text", oggetto: "num_int_aperti", larghezza:'col-lg-3', class: 'bg-warning', clickLink: 'task/attivita?chiuso=0' },
        { nome: "Numero Interventi Giornalieri", tipo: "verticalBar", oggetto: "num_int_giorno", class: 'bg-warning' },
        { nome: "Numero Interventi Giornalieri", tipo: "lineChart", oggetto: "num_int_tipo", class: 'bg-warning', id: 'num-int-tipo',
          linechartOptions: {
            responsive: true,
            lineTension: 0,
            scales: {
              x: { grid: { display: false } },
              y: { grid: { display: false } }
            }
          }
        },
        { nome: "Numero Interventi Per Tipo", tipo: "pieChart", oggetto: "num_tipo_int", class: 'bg-warning' },
        { nome: "Interventi per sesso", tipo: "pieChart", oggetto: "int_sesso", class: 'bg-warning' },
        { nome: "Interventi per titolo di studio", tipo: "pieChart", oggetto: "int_titolo", class: 'bg-warning' },
        { nome: "Interventi per nazionalita", tipo: "pieChart", oggetto: "int_nazionalita", class: 'bg-warning' },
        { nome: "Beneficiari(e) per sesso", tipo: "pieChart", oggetto: "utenti_sesso", class: 'bg-warning' },
        { nome: "Beneficiari(e) per titolo di studio", tipo: "pieChart", oggetto: "utenti_titolo", class: 'bg-warning' },
        { nome: "Beneficiari(e) per nazionalità", tipo: "pieChart", oggetto: "utenti_nazionalita", class: 'bg-warning' }*/
        {
          dataFunc: (x)=>{
            return x.clienti_fat_b2b.map(y=> {
              return {...y, ricorrenza: (parseFloat(y?.ricorrenza?.toString() ?? '0')).toFixed(1)}
            })
          },
          nome: "10 migliori clienti B2B per fatturato - ordini ",
          tipo: "table",
          oggetto: "clienti_fat_b2b",
          larghezza: 'col-lg-12',
          headers: [
            {nome: 'Cliente', oggetti: ['cliente'], inputType: 'text'},
            {nome: 'Fatturato', oggetti: ['fatturato'], inputType: 'text'},
            {nome: 'Ordini', oggetti: ['ordini'], inputType: 'text'},
            {nome: 'Media riordino (gg)', oggetti: ['ricorrenza'], inputType: 'text'}
          ],
          campi: [
            {nome: 'Cliente', oggetti: ['cliente'], inputType: 'text'},
            {nome: 'Fatturato', oggetti: ['fatturato'],inputType:'euro'},
            {nome: 'Ordini', oggetti: ['ordini'], inputType: 'text'},
            {nome: 'Media riordino (gg)', oggetti: ['ricorrenza'], inputType: 'text'}
          ]
        },
        {
          dataFunc: (x)=>{
              return x.clienti_fat_b2c.map(y=> {
                return {...y, ricorrenza: (parseFloat(y?.ricorrenza?.toString() ?? '0')).toFixed(1)}
              })
          },
          nome: "10 migliori clienti B2C per fatturato - ordini ",
          tipo: "table",
          oggetto: "clienti_fat_b2c",
          larghezza: 'col-lg-12',
          headers: [
            {nome: 'Cliente', oggetti: ['cliente'], inputType: 'text'},
            {nome: 'Fatturato', oggetti: ['fatturato'], inputType: 'text'},
            {nome: 'Ordini', oggetti: ['ordini'], inputType: 'text'},
            {nome: 'Media riordino (gg)', oggetti: ['ricorrenza'], inputType: 'text'}
          ],
          campi: [
            {nome: 'Cliente', oggetti: ['cliente'], inputType: 'text'},
            {nome: 'Fatturato', oggetti: ['fatturato'],inputType:'euro'},
            {nome: 'Ordini', oggetti: ['ordini'], inputType: 'text'},
            {nome: 'Media riordino (gg)', oggetti: ['ricorrenza'], inputType: 'text'}
          ]
        },
        { nome: "Account", tipo: "text", oggetto: "num_account", larghezza:'col-lg-4', class: 'bg-kindera' },
        { nome: "Contatti", tipo: "text", oggetto: "num_contatti", larghezza:'col-lg-4', class: 'bg-kindera' },
        { nome: "Lead", tipo: "text", oggetto: "num_lead", larghezza:'col-lg-4', class: 'bg-kindera' },
        { nome: "Acquirenti", tipo: "text", oggetto: "num_clienti", larghezza:'col-lg-4', class: 'bg-kindera' },
        { nome: "Ordini", tipo: "text", oggetto: "num_ordini", larghezza:'col-lg-4', class: 'bg-kindera' },
        { nome: "Vendite", tipo: "euro", oggetto: "num_venduto", larghezza:'col-lg-4', class: 'bg-kindera' }
      ]
    }
  ]
  env.ProgettiAddon = {...env.ProgettiAddon, lavorato: false};
  env.Menu = [{
    module: "Dashboard",
    path: "/dashboard/dynamic",
    title: 'menu.dashboard',
    icon: "mdi mdi-gauge",
    capacita: []
  },...env.Menu]

  return env;
};

var FullEnv = () => {
  var env: any = {};
  env = getModule(Environment());
  env.theme = 'light';
  env.style = 'FortyFix';
  env.sidebarbg = 'skin6';
  env.logoBg = 'skin6';
  env.MainColor = '#3ea26d';
  env.navbarbg = '#FFFFFF';
  env.navbarAccentColor = '#ea582a';
  env.InputLabelColor = '#333333';
  env.InputTextColor = "#4d4d4d";
  env.langSuffix = '_Crm.json';
  env.BreadcrumbType = "MenuBased";
  env.Menu.find(pl => pl?.id == 'att')?.submenu?.find(sl=> sl?.id == 'care')?.submenu.push(
    {
      id: 'C',
      module: "Clienti",
      path: "/task/task/edit/?type=C&tipo=237",
      title: "- Call",
      icon: "mdi mdi-account-group",
      capacita: [],
      class: ''
    },
    {
      id: 'MC', //meeting clienti
      module: "Clienti",
      path: "/task/task/edit/?type=C&tipo=236",
      title: "- Meeting",
      icon: "mdi mdi-account-group",
      capacita: [],
      class: ''
    },
    {
      id: 'S',
      module: "Clienti",
      path: "/task/task/edit/?type=C&tipo=238",
      title: "- Support",
      icon: "mdi mdi-account-group",
      capacita: [],
      class: ''
    },
  )
  return env;
};

export var environment: any = FullEnv();
